import { HttpParams } from '@angular/common/http';
import { ApiV1Job } from '@bluecrew/crew-member-backend-angular-client';

const googleMapsDomain = 'https://www.google.com/maps';
export const openGoogleMaps = (job: ApiV1Job) => {
  const addressLine1 = job.addressDetails.street;
  const addressLine2 = '' + job.addressDetails.city + ', ' + job.addressDetails.state + ', ' + job.addressDetails.zipcode;
  const params = new HttpParams()
        .set('api', '1')
        .set('destination', `${addressLine1}, ${addressLine2}`);
  window.open(`${googleMapsDomain}/dir/?${params.toString()}`);
};
